import React, { useState } from 'react';
import { contactUs } from '../../services/apiService';

function ContactUs() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [purpose, setPurpose] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalMessage, setModalMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const contactData = {
        name,
        email,
        phone: phoneNumber,
        message,
        purposeOfContact: purpose,
      };

      const response = await contactUs(contactData);
      
      // Show success modal
      setModalTitle('Success!');
      setModalMessage('Your message has been sent successfully. We will get back to you soon!');
      setIsSuccess(true);
      setShowModal(true);
      
      // Reset form
      setName('');
      setEmail('');
      setPhoneNumber('');
      setPurpose('');
      setMessage('');
      
    } catch (error) {
      // Show error modal
      setModalTitle('Error!');
      setModalMessage(error.response?.data?.message || 'Something went wrong. Please try again later.');
      setIsSuccess(false);
      setShowModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
    <section className="contact-us-banner py-5 position-relative">
        <div className="overlay-2"></div>
        <div className="container-fluid container-xxl px-md-5 position-relative">
        <div className="row">
             <div className="col-md-12 py-5 contact-banner">
                      <h1 className="text-center text-white">Contact Us</h1>
                      <p className='text-center text-white'>
                        Let's Chat. Reach out to us
                      </p>
                    </div>
        </div>
        </div>
    </section>
    <section className='contact-us-form py-5'>
      <div className="container-fluid container-xxl px-md-5 my-5">
              <div className="row">
              
                    <div className="col-md-6 mx-auto">
  <h4 className='text-center mb-5'>
                    Have Questions or Feedbacks? We are here to Help.
                </h4>
                         <form onSubmit={handleFormSubmit} className='row'>
                          <div className="mb-3 col-md-6">
                              <label htmlFor="name" className="form-label">Name</label>
                              <input
                                  type="text"
                                  className="form-control"
                                  id="name"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  required 
                                  disabled={isLoading} />
                          </div>
                          <div className="mb-3 col-md-6">
                              <label htmlFor="email" className="form-label">Email</label>
                              <input
                                  type="email"
                                  className="form-control"
                                  id="email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  required 
                                  disabled={isLoading} />
                          </div>
                          <div className="mb-3 col-md-6">
                              <label htmlFor="phoneNumber" className="form-label">Phone Number</label>
                              <input
                                  type="tel"
                                  className="form-control"
                                  id="phoneNumber"
                                  value={phoneNumber}
                                  onChange={(e) => setPhoneNumber(e.target.value)}
                                  disabled={isLoading} />
                          </div>
                          <div className="mb-3 col-md-6">
                              <label htmlFor="purpose" className="form-label">Purpose of Contact</label>
                              <select
                                  className="form-select"
                                  id="purpose"
                                  value={purpose}
                                  onChange={(e) => setPurpose(e.target.value)}
                                  disabled={isLoading}
                              >
                                  <option value="">Select...</option>
                                  <option value="general">General Inquiry</option>
                                  <option value="support">Support</option>
                                  <option value="feedback">Feedback</option>
                              </select>
                          </div>
                          <div className="mb-3 col-12">
                              <label htmlFor="message" className="form-label">Message</label>
                              <textarea
                                  className="form-control"
                                  id="message"
                                  rows="6"
                                  value={message}
                                  onChange={(e) => setMessage(e.target.value)}
                                  disabled={isLoading}
                              ></textarea>
                               <button 
                                 type="submit" 
                                 className="mt-5 btn btn-primary w-auto me-auto"
                                 disabled={isLoading}
                               >
                                 {isLoading ? (
                                   <>
                                     <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                     Sending...
                                   </>
                                 ) : (
                                   'Submit'
                                 )}
                               </button>
                          </div>
                         
                      </form>
                        </div> 
                  </div>
              </div>
           </section>

           {/* Bootstrap Modal */}
           <div className={`modal fade ${showModal ? 'show' : ''}`} 
                style={{ display: showModal ? 'block' : 'none' }} 
                tabIndex="-1" 
                aria-labelledby="contactModalLabel" 
                aria-hidden="true">
             <div className="modal-dialog modal-dialog-centered">
               <div className="modal-content">
                 <div className={`modal-header ${isSuccess ? 'bg-success text-white' : 'bg-danger text-white'}`}>
                   <h5 className="modal-title" id="contactModalLabel">{modalTitle}</h5>
                   <button type="button" className="btn-close btn-close-white" onClick={handleCloseModal} aria-label="Close"></button>
                 </div>
                 <div className="modal-body">
                   <p>{modalMessage}</p>
                 </div>
                 <div className="modal-footer">
                   <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>Close</button>
                 </div>
               </div>
             </div>
           </div>

           {/* Modal Backdrop */}
           {showModal && (
             <div className="modal-backdrop fade show" onClick={handleCloseModal}></div>
           )}
          </>
    );

}

export default ContactUs;